<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      v-b-modal.form-shift-detail-modal
      @click="cleanUpForm()"
    >
      Tambah
    </b-button>

    <b-modal
      id="form-shift-detail-modal"
      no-close-on-backdrop
      size="lg"
      :title="(editId == null ? 'Tambah' : 'Edit') + ' Detail Shift'"
    >
      <validation-observer ref="shiftDetailValidation">
        <div class="form">
          <div class="row">
            <div class="col-6">

              <div class="form-group">
                <label for="">Nama</label>
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    v-model="formPayloadShiftDetail.name"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="">Hari</label>
                <validation-provider
                  #default="{ errors }"
                  name="day"
                  rules="required"
                >
                  <b-form-input
                    v-model="formPayloadShiftDetail.day"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="">Jam Masuk</label>
                <validation-provider
                  #default="{ errors }"
                  name="startShift"
                  rules="required"
                >
                  <flat-pickr
                    v-model="formPayloadShiftDetail.startShift"
                    class="form-control"
                    :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="">Jam Pulang</label>
                <validation-provider
                  #default="{ errors }"
                  name="endShift"
                  rules="required"
                >
                  <flat-pickr
                    v-model="formPayloadShiftDetail.endShift"
                    class="form-control"
                    :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

            </div>
          </div>

        </div>
      </validation-observer>

      <template #modal-footer="{}">
        <div v-if="isLoadingShiftDetail">
          <br />
          <b-spinner class="mb-2" variant="primary" /><br />
        </div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="isLoadingShiftDetail"
          @click="submitItem()"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  /* eslint-disable vue/require-default-prop */
  props: {
    formPayload: {
      type: "",
    },
    isLoading: {
      type: Boolean,
    },
    editId: {
      type: Number,
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
    validations: {
      type: "",
    },
    imageAnnouncement: {
      type: String,
    },
    cleanUpForm: {
      type: Function,
    },
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      isLoadingShiftDetail: false,
      formPayloadShiftDetail: {
        day: "",
        endShift: "",
        name: "",
        shiftId: 0,
        startShift: ""
      },
      imageUrl: null,
    };
  },
  watch: {
    purpose(value) {
      this.purposeCoupon = value;
    },
    isLoading(value) {
      this.isLoadingShiftDetail = value;
    },
    validations(value) {
      this.validationsCategory = value;
    },
    formPayload: {
      handler(value) {
        this.formPayloadShiftDetail = value;
        if (this.editId == null) {
          
        }
      },
      deep: true,
    },
    formPayloadShiftDetail: {
      handler(value) {
        this.$emit("payloadShiftDetail", value);
      },
      deep: true,
    },
  },
  methods: {
    submitItem() {
      console.log(this.formPayloadShiftDetail);
      this.$refs.shiftDetailValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },    
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>